import { supabase } from "../lib/supabase";

/**
 * Current user's household membership (RLS: own household).
 * @returns {Promise<{ id: string|null, linked: boolean, memberCount: number }>}
 */
export async function fetchHousehold() {
  const { data, error } = await supabase
    .from("household_members")
    .select("household_id, user_id");
  if (error) throw error;
  const rows = Array.isArray(data) ? data : [];
  if (rows.length === 0) {
    return { id: null, linked: false, memberCount: 0 };
  }
  return {
    id: rows[0].household_id || null,
    linked: rows.length >= 2,
    memberCount: rows.length,
  };
}
